import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { IHeaderParams } from '@ag-grid-enterprise/all-modules';
import { combineLatest, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { LinkAssetServiceService } from 'app/assets/service/link-asset-service.service';
import { UserManagementService } from 'app/user-management/user-management.service';

@Component({
  selector: 'app-checkbox-header-cell',
  templateUrl: './checkbox-header-cell.component.html',
  styleUrls: ['./checkbox-header-cell.component.scss']
})

export class CheckboxHeaderCellComponent {
  params: IHeaderParams | any;
  checkState: Observable<boolean> = of(false);

  constructor(readonly linkAssetServiceService: LinkAssetServiceService, readonly userManagementService: UserManagementService, readonly router: Router) {
      const assetTags$ = this.linkAssetServiceService.selectedNodeTags$;
      this.checkState = combineLatest([assetTags$, this.linkAssetServiceService.checkedLinkTags$])
        .pipe(map(([tags, linkTagsMap]) => tags.length === linkTagsMap.size));
  }

  agInit(params: IHeaderParams): void {
    this.params = params;
  }

  onCheckChange(checked: boolean) {
    if(this.params.context?.parentComponent) {
      this.params.context.parentComponent.checkedAllRow(checked);
    }
  }

}
